export default __webpack_public_path__ + "images/20.27b6cba.png";